<app-entity-mat-dialog-title title="Event"></app-entity-mat-dialog-title>

<div [ngClass]="{ 'loading-shade': showProgressSpinner }">

    <div mat-dialog-content>

        <mat-progress-spinner class="matProgressSpinnerCentered" *ngIf="showProgressSpinner" mode="indeterminate"></mat-progress-spinner>

        <app-error-message [message]=this.errorMessage></app-error-message>

        <form [formGroup]="miscEventFormGroup" (ngSubmit)="onSubmitMiscEvent(f)" #f="ngForm" class="form">
            <div class="container">
                <div class="row">
                    <!-- Event Name -->
                    <div class="col-12">
                        <mat-form-field class="full-width-field">
                            <mat-label>Event Name</mat-label>
                            <input type="text" formControlName="title" name="title" matInput placeholder="Embassy Ball, Jan 2028">
                        </mat-form-field>
                    </div>

                    <!-- Package Code -->
                    <div class="col-12">
                        <mat-form-field class="full-width-field">
                            <mat-label>Package Code</mat-label>
                            <mat-select formControlName="field_package_code" name="field_package_code">
                                <mat-option *ngFor="let code of this._taxonomyService.package_code" [value]="code.id">{{ code.name }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <!-- System-wide toggle (super admins only). Immutable once
                         created, so edit mode shows status instead of a control. -->
                    <div class="col-12 mb-2" *ngIf="canCreateSystemWide && !isEditMode">
                        <mat-checkbox
                            [ngModelOptions]="{standalone: true}"
                            [(ngModel)]="isSystemWide">
                            System-wide event (visible to all studios)
                        </mat-checkbox>
                    </div>
                    <div class="col-12 mb-2" *ngIf="isEditMode && isSystemWide">
                        <span class="badge bg-secondary">System-wide event (visible to all studios)</span>
                    </div>

                    <!-- Event Dates -->
                    <div class="col-12">
                        <mat-form-field class="full-width-field">
                            <mat-label>Event start and end</mat-label>
                            <input matInput
                                required
                                [owlDateTime]="picker_event_date_range"
                                [owlDateTimeTrigger]="picker_event_date_range"
                                [selectMode]="'range'"
                                [(ngModel)]="eventDateRange"
                                [ngModelOptions]="{standalone: true}"
                                placeholder="Select date range"
                                readonly
                                name="field_event_date_range"
                                (dateTimeChange)="eventDateRangeChange($event)">
                            <span class="cursor-pointer" matSuffix [owlDateTimeTrigger]="picker_event_date_range">
                                <mat-icon>calendar_today</mat-icon>
                            </span>
                            <owl-date-time #picker_event_date_range [pickerType]="'calendar'"></owl-date-time>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </form>

        <!-- Delete confirmation (edit mode only) -->
        <div class="container" *ngIf="showDeleteConfirm">
            <div class="row">
                <div class="col-12">
                    <h3>Are you sure? This action can't be undone.</h3>
                </div>
            </div>
        </div>

    </div>

</div>

<mat-dialog-actions align="end">
    <ng-container *ngIf="showDeleteConfirm">
        <button type="button" (click)="cancelDeleteMiscEvent()" mat-raised-button color="accent">Cancel</button>
        <button [disabled]="isDeleting" type="button" (click)="confirmDeleteMiscEvent()" mat-raised-button color="warn">Delete Event</button>
    </ng-container>
    <ng-container *ngIf="!showDeleteConfirm">
        <button type="button" *ngIf="isEditMode" (click)="startDeleteMiscEvent()" mat-raised-button color="warn">Delete</button>
        <button type="button" (click)="closeDialog()" mat-raised-button color="accent">Cancel</button>
        <button [disabled]="!miscEventFormGroup?.valid" type="button" (click)="onSubmitMiscEvent(f)" mat-raised-button color="primary">Save Event</button>
    </ng-container>
</mat-dialog-actions>
